"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectMeta = void 0;
var condition_type_1 = require("./condition-type");
var observable_array_1 = require("./observable-array");
var format_error_1 = require("./format-error");
var ObjectMeta = /** @class */ (function () {
    function ObjectMeta(type, entity, id, isNew) {
        Object.defineProperty(this, "type", { enumerable: true, configurable: false, writable: false, value: type });
        Object.defineProperty(this, "entity", { enumerable: true, configurable: false, writable: false, value: entity });
        Object.defineProperty(this, "id", { enumerable: true, configurable: false, writable: true, value: id });
        Object.defineProperty(this, "isNew", { enumerable: true, configurable: false, writable: true, value: isNew });
        Object.defineProperty(this, "conditions", { enumerable: true, configurable: false, writable: true, value: observable_array_1.ObservableArray.create() });
        Object.defineProperty(this, "__pendingInvocation__", { enumerable: false, configurable: false, writable: false, value: [] });
    }
    /**
     * Gets the condition target with the specified condition type
     * @param conditionType The type of condition to retrieve
     */
    ObjectMeta.prototype.getCondition = function (conditionType) {
        return this.conditions.filter(function (c) { return c.condition.type === conditionType; })[0];
    };
    /**
     * Stores the condition target for the current instance
     * @param conditionTarget The condition target to store
     */
    ObjectMeta.prototype.setCondition = function (conditionTarget) {
        if (conditionTarget.condition.type !== format_error_1.FormatError.ConditionType) {
            this.conditions.push(conditionTarget);
        }
    };
    /**
     * Clears the condition for the current instance with the specified condition type
     * @param conditionType The type of condition to clear
     */
    ObjectMeta.prototype.clearCondition = function (conditionType) {
        for (var i = 0; i < this.conditions.length; i++) {
            var conditionTarget = this.conditions[i];
            if (conditionTarget.condition.type === conditionType) {
                this.conditions.splice(i--, 1);
            }
        }
    };
    /**
     * Determines if the set of permissions are allowed for the current instance
     * @param codes The permission condition type code(s)
     */
    ObjectMeta.prototype.isAllowed = function () {
        var codes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codes[_i] = arguments[_i];
        }
        // ensure each condition type is allowed for the current instance
        for (var c = codes.length - 1; c >= 0; c--) {
            var code = codes[c];
            var conditionType = condition_type_1.ConditionType.get(code);
            // return undefined if the condition type does not exist
            if (conditionType === undefined) {
                return undefined;
            }
            // throw an exception if the condition type is not a permission
            if (!(conditionType instanceof condition_type_1.PermissionConditionType)) {
                throw new Error("Condition type \"" + code + "\" should be a Permission.");
            }
            // return false if a condition of the current type exists and is a deny permission or does not exist and is a grant permission
            if (this.getCondition(conditionType) ? !conditionType.isAllowed : conditionType.isAllowed) {
                return false;
            }
        }
        return true;
    };
    return ObjectMeta;
}());
exports.ObjectMeta = ObjectMeta;
